import {
    FETCH_INVOICES_REQUEST_GAS,
    FETCH_INVOICES_FILTER_REQUEST_GAS,
    RECEIVE_INVOICES_GAS,
    RECEIVE_INVOICES_FILTER_GAS,
    EXPORT_INVOICE_REQUEST_GAS, EXPORT_INVOICE_DONE_GAS,
    CLEAR_INVOICE_PAGINATION_GAS, SET_ITEMS_OFFSET_GAS, SET_FILTERS_GAS,
    RESET_INVOICES
} from '../../../constants/index'
import {
    data_download_api_resource
} from '../../../utils/http_functions'
import saveAs from 'file-saver';

export const resetInvoices = () => {
  return {
    type: RESET_INVOICES
  };
}

export function fetchInvoicesRequest({
  filter='', 
  offset=0,
  limit=100
}) {

  return {
    type: FETCH_INVOICES_REQUEST_GAS,
    payload: {
      filter,
      offset,
      limit
    },
  };
}

export function fetchInvoicesFilterRequest() {
  return {
    type: FETCH_INVOICES_FILTER_REQUEST_GAS
  };
}

export function receiveInvoices(response, errors=null) {
    return {
        type: RECEIVE_INVOICES_GAS,
        payload: {
            response,
            errors
        },
    };
}

export function receiveInvoicesFilter(payload) {
  return {
    type: RECEIVE_INVOICES_FILTER_GAS,
    payload
  };
}

export function changeItemsOffset(newItemsOffset) {
  return {
    type: SET_ITEMS_OFFSET_GAS,
    payload: {
      itemsOffset: newItemsOffset
    }
  }
}

export function changeFilter(newFilters, newItemsPage, newItemsOffset) {
  return {
    type: SET_FILTERS_GAS,
    payload: {
      itemsPage: newItemsPage,
      itemsOffset: newItemsOffset,
      currentFilter: newFilters
    }
  }
}

export function clearPagination(itemsPage) {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_INVOICE_PAGINATION_GAS,
      payload: {
        itemsPage,
      }
    });
  }
}

export function exportInvoiceRequest(invoice) {
  return {
    type: EXPORT_INVOICE_REQUEST_GAS,
    payload: {
      invoice
    },
  };
}

export function exportInvoiceDone(invoice) {
  return {
    type: EXPORT_INVOICE_DONE_GAS,
    payload: {
      invoice
    },
  };
}

export function exportInvoice(token, invoice, report_type) {
  return (dispatch) => {
    dispatch(exportInvoiceRequest(invoice));
    return data_download_api_resource(token, `invoices/${ invoice }/${ report_type }/`, 2)
      .then(response => {
        const filename = response.headers["content-disposition"].split("=");
        saveAs(response.data, filename[1]);
      })
      .catch(error => {
        // if (error.status === 401) {
        //     dispatch(logoutAndRedirect(error));
        // }
      })
      .finally(() => {
        dispatch(exportInvoiceDone(invoice));
      });
  };
}
